import { unleadingSlashIt_default } from "./unleadingSlashIt-DtEoDxRp.mjs";

//#region src/leadingSlashIt.ts
/**
* Adds a leading / to a string, removing any existing leading slash first.
*
* @category Strings
*
* @example
* ```ts twoslash
* import { leadingSlashIt } from '@simplisafe/ewok'
*
* leadingSlashIt('path/to/file') // => '/path/to/file'
* leadingSlashIt('/path/to/file') // => '/path/to/file'
* leadingSlashIt('') // => '/'
* ```
*/
const leadingSlashIt = (s) => `/${unleadingSlashIt_default(s)}`;

//#endregion
export { leadingSlashIt };